<div class="v2-shell">
  <div *ngIf="loading" class="v2-access-status"><mat-spinner diameter="20"></mat-spinner> Berechtigungen werden geladen …</div>
  <p *ngIf="error" class="v2-access-status v2-access-error" role="alert">{{ error }}</p>
  <ng-container *ngIf="access && !loading">
    <nav class="v2-shell-nav" aria-label="Ressourcenplanung">
      <a class="v2-shell-tile" *ngFor="let section of visibleSections" [routerLink]="section.path"
         routerLinkActive="active" [attr.aria-label]="section.label">
        <mat-icon>{{ section.icon }}</mat-icon>
        <span class="tile-text"><strong>{{ section.label }}</strong><small>{{ section.hint }}</small></span>
      </a>
      <a *ngIf="canOpenMonitor" class="v2-shell-monitor" routerLink="/ressourcenplanung/monitor"
         matTooltip="Monitor-Modus"><mat-icon>tv</mat-icon><span>Monitor</span></a>
    </nav>
    <p *ngIf="hasNoTeam" class="v2-access-status v2-access-hint">
      <mat-icon>info_outline</mat-icon>
      Noch keinem Team zugeordnet. Dein Kalender steht dir zur Verfügung; Urlaubsanträge sind möglich, sobald du einem Team angehörst.
    </p>
    <router-outlet></router-outlet>
  </ng-container>
</div>
